// ActionsSection.js

import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, Routes, Route } from 'react-router-dom'; // Import Link, Routes, and Route from React Router
import { isAuthenticated, getUser } from '../utils/auth';

function ActionsSection() {
  const loggedInUser = getUser();
  console.log ("loggedinuser ", loggedInUser);

  return (
    <div>
      {/* Replace the button with a Link to the form */}

      {(loggedInUser.role === 'trainingadmin' || loggedInUser.role === 'admin' || loggedInUser.role === 'masteradmin') && (
                  <>
      <Link to="/training-provider/new-training">
        <Button variant="primary" className="m-1">Create New Training</Button>
      </Link>
      </>
      )}
      {/*
      <Button variant="info" className="m-1">Assign Subordinates</Button>
      */}


    </div>
  );
}

export default ActionsSection;
